import React from "react";
import "./CourseTimeline.css";

const CourseTimeline = ({ title1, imageSrc, title, modules }) => {
  return (
    <div className="course-timeline-container">
      <h1 className="course-structure-title">{title1}</h1>
      {imageSrc && (
        <div className="course-structure-image-wrapper">
          <img
            src={imageSrc}
            alt="Course Structure & Syllabus"
            className="course-structure-image"
          />
        </div>
      )}
      <h2 className="course-timeline-title">{title}</h2>
      <div className="timeline">
        {modules.map((module, index) => (
          <div
            className={`timeline-item ${index % 2 === 0 ? "left" : "right"}`}
            key={index}
          >
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <h3 className="module-title">{module.title}</h3>
              {module.duration && (
                <p className="module-detail">
                  <span>⏳ Duration:</span> {module.duration}
                </p>
              )}
              {module.activities && (
                <p className="module-detail">
                  <span>🎯 Activities:</span> {module.activities}
                </p>
              )}

              <p className="module-detail">
                <span>📚 No. of classes:</span> {module.classes}
              </p>
              <p className="module-detail">
                <span>📝 Description:</span> {module.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CourseTimeline;
